export default __webpack_public_path__ + "static/media/newslider1.84f53fda.jpg";